/**
 * System Logging Utility class
 */
export default class SystemLogger {

  /**
   * Log Debug messages for local build testing
   * 
   */
  static logDebugMessage(message) {
    var isDeveloperBuild = parseInt(process.env.VUE_APP_LOCAL || 0) != 0

    if(isDeveloperBuild) {
      console.debug(`[DEBUG] ${message}`)
    }
  }


  /**
   * Logs error messages
   * Batches up errors to send to the server for UI error logging
   * 
   */
  static logErrorMessage(err, message) {
    console.error(message)

    // TODO: Batch up messages to send to the server
  }



}